export const baseLink = 'https://garden-store-backend.onrender.com';
